/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import "moment-timezone";
import React from "react";
import Moment from "react-moment";
import { DDD_DD_MMM_YYYY, TIME_ZONE } from "../../../../../utils/const";
export const SendReceiveFundsDateFormatter = (cellContent, row, rowIndex) => {
  const { sendOrreceiveFundDate } = row || {};
  return (
    <>
      {sendOrreceiveFundDate && sendOrreceiveFundDate !== "NA" ? (
        <Moment
          date={sendOrreceiveFundDate}
          format={DDD_DD_MMM_YYYY}
          tz={TIME_ZONE}
        />
      ) : (
        "-"
      )}

      <> </>
    </>
  );
};
